<template>
  <div class="spinner-container flex justify-center">
    <svg
      class="spinner"
      :class="small ? 'h-6 w-6' : 'h-8 w-8'"
      viewBox="0 0 50 50"
    >
      <circle :class="[spinnerColor]" cx="25" cy="25" r="20" />
    </svg>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  small: { type: Boolean, default: false },
  gray: { type: Boolean, default: false },
});

const spinnerColor = computed(() => {
  if (props.gray) {
    return "stroke-gray-500 dark:stroke-gray-300";
  }
  return "stroke-sky-700";
});
</script>

<style>
.spinner {
  animation: rotate 2s linear infinite;
}

.spinner circle {
  fill: none;
  stroke-width: 7;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
  transform-origin: 50% 50%;
}

/* Rotate the entire spinner */
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

/* Create the dasharray effect */
@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: -125;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
